module.exports = __webpack_public_path__ + "media/images/vr/index-header-section-m-fb051b648e1c2b7421a4754253e877d2.jpg";